/**
 * Owner: Masa Bayu
 * File: identity.ts
 * Date:Time: 2026-09-05 06:46
 * Description: QXW document identity distinct from application version.
 */
import { QXW_FORMAT, QXW_SCHEMA_VERSION } from './format';
export function createQXDocumentIdentity(id, applicationVersion) {
    return {
        id,
        schema: QXW_FORMAT,
        version: QXW_SCHEMA_VERSION,
        applicationVersion,
    };
}
//# sourceMappingURL=identity.js.map